'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

var _validCCTLD = require('./validCCTLD');

var _validCCTLD2 = _interopRequireDefault(_validCCTLD);

var _validDomainName = require('./validDomainName');

var _validDomainName2 = _interopRequireDefault(_validDomainName);

var _validGTLD = require('./validGTLD');

var _validGTLD2 = _interopRequireDefault(_validGTLD);

var _validPunycode = require('./validPunycode');

var _validPunycode2 = _interopRequireDefault(_validPunycode);

var _validSubdomain = require('./validSubdomain');

var _validSubdomain2 = _interopRequireDefault(_validSubdomain);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var validDomain = (0, _regexSupplant2.default)(/(?:#{validSubdomain}*#{validDomainName}(?:#{validGTLD}|#{validCCTLD}|#{validPunycode}))/, { validDomainName: _validDomainName2.default, validSubdomain: _validSubdomain2.default, validGTLD: _validGTLD2.default, validCCTLD: _validCCTLD2.default, validPunycode: _validPunycode2.default });

exports.default = validDomain;
module.exports = exports['default'];